export const CourseNotFoundIcon = () => (
  <svg
    className="w-48 h-48 text-gray-300 mb-6"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Book/Course icon */}
    <path
      d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    />
    <path
      d="M6.5 2H20v15H6.5A2.5 2.5 0 0 1 4 14.5v-10A2.5 2.5 0 0 1 6.5 2z"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    />

    {/* Search/Magnifying glass */}
    <circle cx="9" cy="9" r="2.5" strokeWidth={1.5} />
    <path
      d="M7 11l-2 2"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    />
  </svg>
)
